.card {
  padding: var(--hs-card-pad);
  min-width: 0;
}
.stack {
  display: flex;
  flex-direction: column;
  gap: var(--hs-spacing-4);
}
.md {
  border-radius: var(--hs-radius-md);
}
.lg {
  border-radius: var(--hs-radius-lg);
}
.surface {
  background: var(--hs-color-bg-surface);
  color: var(--hs-color-text-primary);
  box-shadow: var(--hs-shadow-xs);
}
.sunken {
  background: var(--hs-color-bg-sunken);
  color: var(--hs-color-text-primary);
}
.inverse {
  background: var(--hs-color-bg-inverse);
  color: var(--hs-color-text-on-inverse);
  box-shadow: var(--hs-shadow-xl);
}
